<script>
  import axios from 'axios';

  export default {
    name: "",
    props: {
      agreement: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        visible: false,
        cashes: [],
        form: {
          OnlineCashId: 0,
          BillProvideTypeId: 1,
        }
      }
    },
    methods: {
      async init() {
        this.cashes = await this.getList();
        if (this.cashes.length) {
          this.form.OnlineCashId = this.cashes[0].value
        }
      },
      getList() {
        return new Promise((resolve, reject) => {
          //TODO: необходимо разкомментировать
          if (!this.agreement) {
            return resolve([]);
          }
          axios
            .get(
              `/tourclient/settings/onlineCashSettingsList?AgreementCode=${encodeURIComponent(this.agreement)}`,
            )
            .then(({data}) => {
              resolve(data.OnlineCashes ? data.OnlineCashes.map(i => ({
                ...i,
                value: i.Id,
                label: `${i.Name} ${i.LegalEntityId ? ('(' + i.LegalEntityName + ')') : ''}`,
              })) : []);
            })
            .catch(() => {
              resolve([]);
            })
        });
      },
      handleClose(done) {
        this.visible = false;
        done();
      }
    },
    computed: {},
    watch: {
      watch: {
        agreement(){
          this.init();
        }
      },
    },
    components: {},
    mounted() {
      this.init()
    },
    destroyed() {
    },
  }
</script>
<template>
  <el-button type="primary" @click="visible=true" :disabled="!cashes.length">
    Я онлайн касса свежая, не работающая!
    <el-dialog
      :visible="visible"
      :before-close="handleClose"
      width="400px"
      append-to-body
      title="Онлайн касса"
    >
      <div>А я селелект с кассами пока не существующий, но будущий</div>
      <OnlineCashesForm
        :cashes="cashes"
        :form="form"
      >
      </OnlineCashesForm>
      <div style="text-align: right">
        <el-button @click="visible=false">Отмена</el-button>
        <el-button type="primary">А я кнопка, просто кнопка submit</el-button>
      </div>
    </el-dialog>
  </el-button>
</template>
<style lang="scss">
</style>
